import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Subject } from 'rxjs';
import type { ToastContentInterface } from '../toast';

@Component({
  selector: 'ppl-toast-message',
  templateUrl: 'toast-message.component.html',
  styleUrls: ['toast-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ToastMessageComponent implements ToastContentInterface {

  closeToast$ = new Subject<null>();
  actionClicked?: () => void;

  message: string;
  actionText: string;
  showClose = false;

  onActionClicked() {
    this.actionClicked?.();
    this.dismiss();
  }

  onClose() {
    this.dismiss();
  }

  dismiss() {
    this.closeToast$.next(null);
    this.closeToast$.complete();
  }
}
